import { render, staticRenderFns } from "./FormAluno.vue?vue&type=template&id=3f05beea&scoped=true&"
import script from "./FormAluno.vue?vue&type=script&lang=js&"
export * from "./FormAluno.vue?vue&type=script&lang=js&"
import style0 from "./FormAluno.vue?vue&type=style&index=0&id=3f05beea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05beea",
  null
  
)

export default component.exports